import React from 'react';
import {doesAbsenceOverlap, isWithinAbsencePeriod} from "../../utils";
import {useTranslation} from "react-i18next";

// React Components
import InputSelect from '../InputSelect/InputSelect';

// CSS Files
import './AvailabilityModule.css';

const AvailabilityModule = (props) => {
   const { t } = useTranslation();
   const handleChange = (key, value) => {
      let availability = {...props.data};
      availability[key] = value;
      props.availabilityChanged(availability);
   }

   const gameWeekDays = Array.from({ length: 7 }, (_, index) => new Date(new Date(props.gameWeekStartDate).setDate(props.gameWeekStartDate.getDate() + index)));

   return <div className={"pb-4"} id={props.id}>
      <InputSelect labelClasses="select-label" text={t("availabilities_page.availability_working_day", { availabilityNumber: props.availabilityNumber })} showTextTooltip={props.showTextTooltip}>
         <select className="input-background" value={props.data.day} onChange={(event) => handleChange("day", event.target.value)} disabled={props.disableInputs}>
            <option value="" disabled>{t("common.form.options.choose_an_option")}</option>
            <option value="Segunda-feira" disabled={isWithinAbsencePeriod(gameWeekDays[0], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.monday")}</option>
            <option value="Terca-feira" disabled={isWithinAbsencePeriod(gameWeekDays[1], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.tuesday")}</option>
            <option value="Quarta-feira" disabled={isWithinAbsencePeriod(gameWeekDays[2], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.wednesday")}</option>
            <option value="Quinta-feira" disabled={isWithinAbsencePeriod(gameWeekDays[3], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.thursday")}</option>
            <option value="Sexta-feira" disabled={isWithinAbsencePeriod(gameWeekDays[4], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.friday")}</option>
            {props.allowExtraOptions || (doesAbsenceOverlap(props.absenceStartDate, props.absenceEndDate, props.gameWeekStartDate, props.gameWeekEndDate) && props.absenceEndDate.getDay() !== 1) &&
               <>
                  <option value="Sabado" disabled={isWithinAbsencePeriod(gameWeekDays[5], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.saturday")}</option>
                  <option value="Domingo" disabled={isWithinAbsencePeriod(gameWeekDays[6], props.absenceStartDate, props.absenceEndDate)}>{t("registration_page.availabilities.sunday")}</option>
               </>
            }
         </select>
      </InputSelect>

      <div>
         <label className="availability-label">{t("availabilities_page.starting_hour")}</label>
         {props.allowExtraOptions && !props.disableInputs && <button onClick={props.removeAvailability} className="astext">{t("availabilities_page.remove")}</button>}
      </div>

      <div className="game-times-wrapper">
         <div className="game-times-container">
            <div className="game-times-selector">
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_morning"} checked={!!props.data.available_morning}
                      onChange={(event) => handleChange("available_morning", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_morning"}>{t("availabilities_page.morning")}</label>
            </div>

            <div className="game-times-selector">
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_lunch"} checked={!!props.data.available_lunch}
                      onChange={(event) => handleChange("available_lunch", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_lunch"}>{t("availabilities_page.lunch")}</label>
            </div>

            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_afternoon"} checked={!!props.data.available_afternoon}
                      onChange={(event) => handleChange("available_afternoon", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_afternoon"}>{t("availabilities_page.afternoon")}</label>
            </div>
         </div>

         <div className="game-times-container">
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1800"} checked={!!props.data.t1800}
                      onChange={(event) => handleChange("t1800", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1800"}>{t("availabilities_page.18h")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1830"} checked={!!props.data.t1830}
                      onChange={(event) => handleChange("t1830", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1830"}>{t("availabilities_page.18h30")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1900"} checked={!!props.data.t1900}
                      onChange={(event) => handleChange("t1900", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1900"}>{t("availabilities_page.19h")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1930"} checked={!!props.data.t1930}
                      onChange={(event) => handleChange("t1930", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_1930"}>{t("availabilities_page.19h30")}</label>
            </div>
         </div>

         <div className="game-times-container">
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2000"} checked={!!props.data.t2000}
                      onChange={(event) => handleChange("t2000", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2000"}>{t("availabilities_page.20h")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2030"} checked={!!props.data.t2030}
                      onChange={(event) => handleChange("t2030", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2030"}>{t("availabilities_page.20h30")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2100"} checked={!!props.data.t2100}
                      onChange={(event) => handleChange("t2100", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2100"}>{t("availabilities_page.21h")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2130"} checked={!!props.data.t2130}
                      onChange={(event) => handleChange("t2130", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2130"}>{t("availabilities_page.21h30")}</label>
            </div>
         </div>

         <div className="game-times-container">
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2200"} checked={!!props.data.t2200}
                      onChange={(event) => handleChange("t2200", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2200"}>{t("availabilities_page.22h")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2230"} checked={!!props.data.t2230}
                      onChange={(event) => handleChange("t2230", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2230"}>{t("availabilities_page.22h30")}</label>
            </div>
            <div>
               <input type="checkbox" id={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2300"} checked={!!props.data.t2300}
                      onChange={(event) => handleChange("t2300", event.target.checked)} disabled={props.disableInputs}></input>
               <label htmlFor={"availability_" + props.week + "_" + props.availabilityNumber + "_checkbox_2300"}>{t("availabilities_page.23h")}</label>
            </div>
         </div>
      </div>
   </div>
}

export default AvailabilityModule;